import getBenefits from './getBenefits'

export default {
  getBenefits,
}
